import {
  JessePooler_Tacoma,
  SarahLund_Bellevue,
  NormanFabula_FederalWay,
  JackieSchultz_Lakewood,
  JoeyJove_Olympia,
  JoeyJove_Puyallup,
  KristinaBondar_Sumner,
} from "./raw/directors";

import {
  Tacoma,
  Bellevue,
  FederalWay,
  Lakewood,
  Olympia,
  Puyallup,
  Sumner,
} from "./raw/officeLocations";

const TacomaData = {
  directorData: JessePooler_Tacoma.directorData,
  biographyData: JessePooler_Tacoma.biographyData,
  locationData: Tacoma.locationData,
};

const BellevueData = {
  directorData: SarahLund_Bellevue.directorData,
  biographyData: SarahLund_Bellevue.biographyData,
  locationData: Bellevue.locationData,
};

const FederalWayData = {
  directorData: NormanFabula_FederalWay.directorData,
  biographyData: NormanFabula_FederalWay.biographyData,
  locationData: FederalWay.locationData,
};

const LakewoodData = {
  directorData: JackieSchultz_Lakewood.directorData,
  biographyData: JackieSchultz_Lakewood.biographyData,
  locationData: Lakewood.locationData,
};

const OlympiaData = {
  directorData: JoeyJove_Olympia.directorData,
  biographyData: JoeyJove_Olympia.biographyData,
  locationData: Olympia.locationData,
};

const PuyallupData = {
  directorData: JoeyJove_Puyallup.directorData,
  biographyData: JoeyJove_Puyallup.biographyData,
  locationData: Puyallup.locationData,
};

const SumnerData = {
  directorData: KristinaBondar_Sumner.directorData,
  biographyData: KristinaBondar_Sumner.biographyData,
  locationData: Sumner.locationData,
};

const clinicLocations = [
  {
    ...TacomaData.locationData,
    director: TacomaData.directorData.directorName,
  },
  {
    ...BellevueData.locationData,
    director: BellevueData.directorData.directorName,
  },
  {
    ...FederalWayData.locationData,
    director: FederalWayData.directorData.directorName,
  },
  {
    ...LakewoodData.locationData,
    director: LakewoodData.directorData.directorName,
  },
  {
    ...OlympiaData.locationData,
    director: OlympiaData.directorData.directorName,
  },
  {
    ...PuyallupData.locationData,
    director: PuyallupData.directorData.directorName,
  },
  {
    ...SumnerData.locationData,
    director: SumnerData.directorData.directorName,
  },
];

export {
  TacomaData,
  BellevueData,
  FederalWayData,
  LakewoodData,
  OlympiaData,
  PuyallupData,
  SumnerData,
  clinicLocations,
};
